/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import SocialAvatar from 'app/components/common/SocialAvatar.jsx';
import ConstantMixin from 'app/mixins/ConstantMixin.js';

class PostSocialButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isActive: false,
            rolloverActive: false,
            showLabels: false,
            isSelectable: true,
        };

        this.buttonRef = React.createRef();
        this.showRollover = this.showRollover.bind(this);
        this.hideRollover = this.hideRollover.bind(this);
        this.timeoutId = React.createRef();

    }

    static getDerivedStateFromProps(props, state) {
        let nextState = null,
            setNextState = (key, value) => {
                if (nextState === null) {
                    nextState = {};
                }

                nextState[key] = value;

            };

        if (props.isActive !== undefined && props.isActive !== state.isActive) {
            setNextState('isActive', props.isActive);
        }

        if (props.showLabels !== undefined && props.showLabels !== state.showLabels) {
            setNextState('showLabels', props.showLabels);
        }

        if (props.isSelectable !== undefined && props.isSelectable !== state.isSelectable) {
            setNextState('isSelectable', props.isSelectable);
        }

        return nextState;

    }

    componentDidMount() {
        if (this.buttonRef.current) {
            this.buttonRef.current.addEventListener('mouseover', this.showRollover);
            this.buttonRef.current.addEventListener('mouseleave', this.hideRollover);
        }

        if (this.props.listContainerRef !== undefined && this.props.listContainerRef.current) {
            this.props.listContainerRef.current.addEventListener('scroll', this.hideRollover);
        }

    }

    componentWillUnmount() {
        if (this.buttonRef.current) {
            this.buttonRef.current.removeEventListener('mouseover', this.showRollover);
            this.buttonRef.current.removeEventListener('mouseleave', this.hideRollover);
        }

        if (this.props.listContainerRef !== undefined && this.props.listContainerRef.current) {
            this.props.listContainerRef.current.removeEventListener('scroll', this.hideRollover);
        }

    }

    showRollover(e) {
        if (!this.timeoutId.current) {
            this.timeoutId.current = window.setTimeout(() => {
                this.setState({
                    rolloverActive: true
                });
            }, 750);
        }
    }

    hideRollover(e) {
        if (this.timeoutId.current) {
            window.clearTimeout(this.timeoutId.current);
            this.timeoutId.current = 0;
        }


        if (this.state.rolloverActive) {
            this.setState({
                rolloverActive: false
            });
        }
    }

    render () {
        let activeClass = this.state.isActive ? 'active' : 'inactive',
            rollover = null,
            label = null,
            subTypeLabel = null,
            rolloverTop = '0px',
            rolloverLeft = '0px',
            styles = {},
            constants = this.props.app.config.constants;

        if (this.buttonRef.current && this.state.rolloverActive) {
            let slop = (this.state.showLabels) ? 5 : 10;

            if (this.props.listContainerRef !== undefined && this.props.listContainerRef.current) {
                rolloverTop = Math.round((this.buttonRef.current.offsetTop - this.props.listContainerRef.current.scrollTop) - ((this.buttonRef.current.offsetHeight / 2) - slop));
                styles = {
                    top: `${rolloverTop}px`
                };
            }

        }

        if (this.state.showLabels && (this.props.connect === undefined || !this.props.connect)) {
            activeClass += " with-label";
            if (this.props.social.subType !== undefined) {
                subTypeLabel = (
                    <div className="subtype">
                        {ConstantMixin.getSubtypeLabel(this.props.social.subType)}
                    </div>
                );
            }

            label = (
                <div className="pt-social-label">
                    <div className="social-name">{this.props.social.name}</div>
                    {subTypeLabel}
                </div>
            );
        }

        if (this.props.connect !== undefined && this.props.connect) {
            let connectClass = 'pt-social-button pt-new-social';

            if (this.state.rolloverActive) {
                rollover = (
                    <div className='pt-social-rollover' style={styles}>
                        Connect New
                    </div>
                );
            }

            if (this.state.showLabels) {
                connectClass += ' with-label';
                label = (
                    <div className="pt-social-label">
                        <div className="social-name">Add</div>
                    </div>
                );
            }

            return (
                <div ref={this.buttonRef} role="button" aria-label="Connect New Social" className={connectClass} onClick={this.props.onClick} data-socialid={0}>
                    {rollover}
                    <div className="pt-new-social">
                        <i className="icon ion-plus-round"></i>
                    </div>
                    {label}
                </div>
            )
        }

        if (this.state.rolloverActive) {
            let rolloverContent = this.props.social.name;
            if (this.props.social.psID === constants.POST_SVC_TWITTER && this.props.app.config.twitterDisabled !== undefined && this.props.app.config.twitterDisabled) {
                rolloverContent = "X (Twitter) is unavailable";
            }
            if (!this.state.isSelectable && this.props.social.psID === constants.POST_SVC_YOUTUBE) {
                rolloverContent = "Choose one YouTube channel per post";
            }
            rollover = (
                <div className='pt-social-rollover' style={styles}>
                    {rolloverContent}
                </div>
            );
        }

        return (
            <div ref={this.buttonRef}
                className={`pt-social-button ${activeClass}`}
                onClick={this.props.onClick}
                data-socialid={this.props.social.id}
                data-socialtype={this.props.social.psID}>
                {rollover}
                <div className="avatar-wrapper">
                    <SocialAvatar
                        social={this.props.social}
                        hideAlt={true}
                        unselected={!this.state.isActive}/>
                </div>
                {label}
            </div>
        );
    }
};

PostSocialButton.displayName = "PostSocialButton";

export default PostSocialButton;
